import { clearCsrfTokenFallback } from '@/utils/csrfToken'

export const AUTH_SESSION_INVALIDATED_EVENT = 'auth:session-invalidated'

export function clearPersistedAuthSession(): void {
  clearCsrfTokenFallback()
  localStorage.removeItem('authToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('user')
}

export function dispatchAuthSessionInvalidated(): void {
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_INVALIDATED_EVENT))
}
